import { AttributesMixin, define, Model } from "@type-r/models";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";

export interface ValidationResponse {
    isValid: boolean,
    errors: string[]
}

export interface ImportTemplateValidation extends AttributesMixin<typeof ImportTemplateValidation> { }

@define
export class ImportTemplateValidation extends Model {
    static endpoint = restfulIO('api/v1/ingest/import-templates/validate');
}

export async function validation(id, name, assetTypes, isDefault, companies): Promise<ValidationResponse> {
    let url: string = `api/v1/ingest/import-templates/validate`;
    let payload = {
        name,
        assetTypes,
        isDefault,
        companies
    };
    if (id) {
        payload = { ...payload, ...{ id } }
    }

    return (await fetch(url, {
        method: 'POST',
        headers: new Headers({
            "Authorization": getAuthorizationBearer(),
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Platform-Code': getPlatformCode()
        }),
        body: JSON.stringify(payload)
    })).json();
}
